import translationLoader from './translations-loader';
import localeSetter from './locale-setter';

export default {
  translationLoader,
  localeSetter,
};
